import Highcharts from 'highcharts';

export const figure53 = {
chart: {
zoomType: 'xy',
animation: false,
marginTop: 50,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height: '700px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
 fontFamily: 'Montserrat'
}
},
credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},
plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
}
},
exporting: {
enabled: false
},
xAxis: [{
tickWidth: 0,
labels: {
  groupedOptions: [{
style: {
transform: 'unset'
},
}],
style: {
transform: 'translateX(11px)'
},
align: 'right'
},
categories: [
{
  name: "أوقيانوسيا (باستثناء أستراليا ونيوزيلندا)",
  categories: ["بولينيزيا", "ميكرونيزيا", "ميلانيزيا"]
},
{
  name: "غرب آسيا وشمال أفريقيا",
	categories: ["شمال أفريقيا", "غرب آسيا"]
},
{
  name: "أفريقيا جنوب الصحراء الكبرى",
	categories: ["جنوب أفريقيا", "غرب أفريقيا", "وسط أفريقيا", "جنوب أفريقيا"]
},
{
  name: "شرق آسيا وجنوب شرق آسيا",
	categories: ["جنوب شرق آسيا","شرق آسيا"]
},
{
  name: "آسيا الوسطى وجنوب آسيا",
	categories: ["آسيا الوسطى", "جنوب آسيا"]
},
{
  name: "أمريكا اللاتينية ومنطقة البحر الكاريبي",
	categories: ["أمريكا الجنوبية", "أمريكا الوسطى", "منطقة البحر الكاريبي"]
},
{
  name: "أمريكا الشمالية وأوروبا",
	categories: ["جنوب أوروبا", "أوروبا الغربية", "شمال أوروبا", "أوروبا الشرقية", "أمريكا الشمالية"]
},

      ],
      lineColor: "#d7d7d7",
      tickColor: "#d7d7d7",
      tickLength: 25,
}],
yAxis: [{
  labels: {
		  style: {
				 fontWeight: 'normal',
				 color: '#999999',
				 fontSize: '11px'
			 },
	  },
	  min: 80,
	  max: 110,
	  tickInterval: 10,	
	  format: '{value}%',
	  gridLineWidth: 1,
	  floor: 0,

	  title: {
		  text: '',
		  style: {
				color: Highcharts.getOptions().colors[1]
			}
	  }
}],
tooltip: {
  shared: true,
  useHTML: true,
  hideDelay: 500,
  backgroundColor: null,
  borderWidth: 0,
  shadow: false,
  valueSuffix: '%',
  style: {
		  padding: 0
	  }
},
legend: {
  enabled: false,
},

series: [{
  name: '',
  color: '#bf9000',
  data: [
	 100.71,
	 98.16,
	 102.31,
	 103.19,
	 101.36,
	 100.24,
	 85.70,
	 104.29,
	 88.14,
	 97.72,
	 99.72,
	 99.99,
	 97.73,
	 97.91,
	 99.69,
	 99.62,
	 97.81,
	 102.48,
	 100.84,
	 98.77,
	 105.14,
	]
}]
}
